module.exports = __webpack_public_path__ + "75698b1310426e3f9fd9090dba922d60.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/amusement-parks/UniversalStudios2.jpg
// module id = 3267
// module chunks = 0